export interface ICompanyDetails {
    type?: string
    id: number
    name?: string
    logoPath?: string
    type?: number
    createDate?: Date
    status?: number
    clientId?: number
    creatorName?: string
    companiesModules?: ICompaniesModule[]
    companyDocuments?: ICompanyDocument[]
    layout?: Layout[]
    formsPhoneNum?: string
    printintgHouseId?: number
    paymentServiceId?: number
    paymentTerminal?: string
    headerImage?: string
    centralBannerImage?: string
    leftBannerImage?: string
    leftBannerLink?: string
    centralBannerLink?: string
    video?: string
    isInMastSite: boolean
    createdUserName?: string
    isPaymentServiceOnline: boolean
    isConflictPaymentServiceOnline: boolean
    paymentTerminalUser?: string
    paymentTerminalPassword?: string
    isNew: boolean
    isPersonalArea: boolean
    isParticipantInFile4: boolean
    isViewWaterDataFromPriority: boolean
    standingOrderTerminal?: string
    standingOrderTerminalUser?: string
    standingOrderTerminalPassword?: string
    isActiveStandingOrderTerminal: boolean
    externalCrmSystemId?: number
    externalCrmSystemCompanyName?: string
    externalCrmSystemPassword?: string
    distributionChannels?: IDistributionChannel[]
    distributionChannelsIds?: number[]
    isSelectWhatsAppTemplate: boolean
    whatsAppTemplateId?: number
    waterMeterReaderSupplier?: number
    waterMeterReaderCompanyCode?: string
    waterMeterReaderSupplierApiKey: string
    waterMeterReaderSupplierUrl: string
    waterMeterReaderSupplierUser: string
    isDisplayVideoInMast: boolean
    isDispalyTopLeftBannerInMast: boolean
    isDispalyLowerLeftBannerInMast: boolean
    billTemplateImageUrl?: string
    isShowTranslation: boolean
    isRegistrationToTaagid: boolean
    taagidId?: number
    isMultiplePaymentsStandingOrder: boolean
    isAutomationPendingBalance: boolean
    automationUserName: string
    automationCustomerId: string
    automationCustomerSite: string
    automationPassword: string
    automationSender: string
    automationApiUrls: IAutomationApiUrls[]
}

export interface IModuleSettingsType {
    id: number
    typeName: string
    moduleTypeId: number
    moduleSettings: any[]
}

export interface IPaymentSettingsEpr {
    moduleSettingId: number
    userName: string
    passWord: string
    id: number
}

export interface IPaymentSettingsMetro {
    moduleSettingId: number
    guid: string
    id: number
}

export interface IModuleSetting {
    id: number
    moduleSettingsTypeId: number
    moduleSettingsType: ModuleSettingsType
    companiesModules: ICompaniesModule[]
    paymentSettingsEpr: PaymentSettingsEpr[]
    paymentSettingsMetro: PaymentSettingsMetro[]
}

export interface IEmoduleSettingsType {
    id: number
    typeName: string
    moduleTypeId: number
    moduleSettings: any[]
}

export interface IModuleType {
    id: number
    name: string
    isActive: boolean
    requiresSettings: boolean
}

export interface ICompaniesModule {
    companyId: number
    moduleTypeId: number
    status: number
    createDate: string | date | moment
    expirationDate: string | date | moment
    isWeb: boolean
    isApp: boolean
    moduleSettingTypeId: number
    id: number
    key?: number
    settings?: IModuleSettings[]
}
export interface IModuleSettings {
    name: string
    label: string
    type: string
    value: string
    isRequired: boolean
    options?: IModuleSettingsOptions[]
}

export interface IModuleSettingsOptions {
    id: number
    name: string
}

export interface ICompanyDocument {
    id: number
    companyId: number
    documentPath: string
    documentName: string
    uploaderUserName: string
    uploadDate: Date | string
    isActive: boolean
    key: number
    documentByte?: string
}

export interface CompanyMedia {
    headerImage?: string
    centralBannerImage?: string
    leftBannerImage?: string
    leftBannerLink?: string
    centralBannerLink?: string
    video?: string
}
export interface IDistributionChannel {
    id: DistributionChannelType
    name: string
    logoUrl: string
    whatsAppTemplate: IWhatsAppTemplate
}

export interface IWhatsAppTemplate {
    id: number
    name: string
    inwiseId: number
    templateText: string
}

export interface IAutomationApiUrlType {
    type: number
    name: string
}

export interface IAutomationApiUrl {
    url: number
    type: number
}

export enum DISTRIBUTION_CHANNEL_TYPE {
    SMS = 1,
    Email = 2,
    WhatsApp = 3
}

export enum WATER_METER_READER_SUPPLIER {
    None = 0,
    Miltel = 3,
    Rimonim = 4,
    Gaon = 5,
    Arad = 6,
    AradHarmony = 7
}
